import Cookies from 'js-cookie';
import { UserModule } from '@/store/modules/user';


const TOKEN_KEY = 'prestigehubs-access-token';
export const getToken = () => Cookies.get(TOKEN_KEY) || '';
export const removeToken = () => Cookies.remove(TOKEN_KEY);
export const setToken = (token: string) => Cookies.set(TOKEN_KEY, token);
